import { render, staticRenderFns } from "./schedule-delegation-settings.vue?vue&type=template&id=c208134c&lang=pug&"
import script from "./schedule-delegation-settings.vue?vue&type=script&lang=js&"
export * from "./schedule-delegation-settings.vue?vue&type=script&lang=js&"
import style0 from "./schedule-delegation-settings.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports